// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-divider[data-v-2fd997f4]{padding:5px 0;margin:0 35px;border-top-width:2px;border-top-style:solid;border-top-color:#c3c2c7}.custom-app-bar[data-v-2fd997f4]{background-color:transparent!important;border-bottom:none!important}", ""]);
// Exports
module.exports = exports;
